if (!customElements.get('pet-favorites')) {
  customElements.define(
    'pet-favorites',
    class PetFavorites extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          if (event.target.closest('[data-prev]')) this.scrollByCard(-1);
          if (event.target.closest('[data-next]')) this.scrollByCard(1);
        };
        this.onScroll = () => this.updateControls();
        this.addEventListener('click', this.onClick);
        window.addEventListener('resize', this.onScroll);

        this.trackObserver = new MutationObserver(() => this.bindTrack());
        this.trackObserver.observe(this, { childList: true, subtree: true });
        this.bindTrack();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.trackObserver?.disconnect();
      }

      bindTrack() {
        const track = this.querySelector('[data-track]');
        if (track === this.track) {
          this.updateControls();
          return;
        }

        this.track?.removeEventListener('scroll', this.onScroll);
        this.track = track;
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateControls();
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.pet-favorites__card');
        if (!card) return;
        const styles = getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const perView = window.matchMedia('(max-width: 749px)').matches ? 2 : 1;
        this.track.scrollBy({
          left: (card.getBoundingClientRect().width + gap) * direction * perView,
          behavior: 'smooth',
        });
      }

      updateControls() {
        if (!this.track) return;
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.controls = this.querySelector('[data-controls]');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const canScroll = maxScroll > 4;
        if (this.controls) this.controls.hidden = !canScroll;
        this.prevButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
